import { useState, useCallback } from 'react';

export type Phase =
  | 'validate'
  | 'access-card'
  | 'access-granted'
  | 'walkthrough'
  | 'waiting-room'
  | 'meeting'
  | 'ended';

export function useMeetingPhase(initial: Phase = 'validate') {
  const [phase, setPhase] = useState<Phase>(initial);

  const advancePhase = useCallback((to: Phase) => {
    setPhase(to);
  }, []);

  return { phase, advancePhase };
}
